/**
 * Fog of war time machine (docs/fog-of-war/README.md): lay a server snapshot
 * (GET /games/:id/snapshot, the board as this player could see it then) over
 * the map. Snapshot fog replaces the live fog: a territory fogged now but
 * seen then shows what was seen, and vice versa. Territories missing from the
 * snapshot keep their current values.
 */
import type { MapDef, WireTerritory } from '@warcarp/api-types'

type Territory = MapDef['territories'][number]

export function applyFogSnapshot(territories: readonly Territory[], snapshot: readonly WireTerritory[]): Territory[] {
  const byId = new Map(snapshot.map((t) => [t.id, t]))
  return territories.map((t) => {
    const seen = byId.get(t.id)
    if (!seen) return t
    const { fogged: _live, ...base } = t
    return seen.fogged
      ? { ...base, ownerId: seen.ownerId ?? '', armies: 0, fogged: true }
      : { ...base, ownerId: seen.ownerId ?? '', armies: seen.armies ?? 0 }
  })
}
